import { useCallback, useEffect, useState } from 'react'
import type { ChangeEvent } from 'react'

// 参考：https://usehooks-ts.com/react-hook/use-debounce
export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500)
    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])
  return debouncedValue
}

export function useDebouncedOnChange(set: (val: string) => void, initial = '') {
  const [value, setValue] = useState(initial)
  const debounced = useDebounce(value)

  useEffect(() => {
    set(debounced)
  }, [set, debounced])

  return useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setValue(e.target.value)
    },
    [setValue]
  )
}
